/**
 * Route Selector
 *
 * Este módulo selecciona dinámicamente las rutas según el cliente/tenant activo.
 * Permite tener diferentes configuraciones de rutas para diferentes clientes.
 */

import { tenants } from 'app/config/config';

/**
 * Obtiene las rutas configuradas para un cliente específico
 * @param {string} client - El identificador del cliente
 * @returns {Object} - Objeto con externalRoutes, publicRoutes, privateRoutes, localhostRoutes
 */
export function getRoutesForClient(client) {
  // Si el cliente es Edelvives, cargar sus rutas específicas
  if (client === 'edelvives' || client === tenants.edelvives) {
    return import('edelvives/router/routesConfig');
  }

  // Por defecto, usar las rutas de app (Tangerine)
  return import('app/router/routesConfig');
}

/**
 * Hook para obtener las rutas del cliente actual de forma síncrona
 * Esto es útil para componentes que necesitan las rutas inmediatamente
 */
export function getRoutesForClientSync(client) {
  // Si el cliente es Edelvives, usar sus rutas
  if (client === 'edelvives' || client === tenants.edelvives) {
    try {
      // Require síncrono para evitar lazy loading en rutas críticas
      return require('edelvives/router/routesConfig');
    } catch (error) {
      console.warn('Edelvives routes not found, falling back to default routes', error);
      return require('app/router/routesConfig');
    }
  }

  // Por defecto, usar las rutas de app
  return require('app/router/routesConfig');
}

export default getRoutesForClient;
